module.exports = __webpack_public_path__ + "static/media/pandemic_alert_small.15e4abfa.png";